import React, { useEffect, useState } from 'react';
import { Modal, Select, Alert, Spin, Button } from 'antd';
import { message } from '../../utils/antdMessage';

/**
 * 系统管理员勾选：该帐号可代管哪些组织的队伍品牌文字。
 * 与队员可见范围 user_member_scope 分开。
 */
export default function UserOrgBrandingScopeModal({
  visible,
  userId,
  userName,
  onClose,
  apiRequest
}) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [orgOptions, setOrgOptions] = useState([]);
  const [selectedOrgs, setSelectedOrgs] = useState([]);
  const [loadError, setLoadError] = useState('');
  const normalizedUserId = userId != null && userId !== '' ? Number(userId) : null;

  useEffect(() => {
    if (visible && normalizedUserId) {
      fetchData();
    }
    if (!visible) {
      setSelectedOrgs([]);
      setLoadError('');
    }
  }, [visible, normalizedUserId]);

  const fetchData = async () => {
    setLoading(true);
    setLoadError('');
    try {
      const [scopeData, orgData] = await Promise.all([
        apiRequest(`/api/admin/user-org-branding-scope/${normalizedUserId}`),
        apiRequest('/api/admin/org-group-options')
      ]);
      if (scopeData?.success) {
        setSelectedOrgs(scopeData.org_names || []);
        if (scopeData.tableNotExists) {
          message.warning('user_org_branding_scope 表不存在，请先执行数据库迁移');
        }
      } else {
        setSelectedOrgs([]);
        setLoadError(scopeData?.error || '加载代管组织失败');
      }
      if (orgData?.success) {
        const names = (orgData.organizations || []).map((o) => o.org_name).filter(Boolean);
        setOrgOptions(names);
      }
    } catch (error) {
      setSelectedOrgs([]);
      setLoadError('加载数据失败');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const response = await apiRequest(`/api/admin/user-org-branding-scope/${normalizedUserId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ org_names: selectedOrgs })
      });
      if (response?.success) {
        message.success('品牌代管组织已保存');
        onClose?.();
      } else {
        message.error(response?.error || '保存失败');
      }
    } catch (error) {
      message.error('保存失败');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={`品牌代管组织 - ${userName || '用户'}`}
      onCancel={onClose}
      onOk={handleSave}
      confirmLoading={saving}
      destroyOnHidden
      width={560}
    >
      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
        message="仅系统管理员可勾选。帐号无所属组织时，仍可通过此处代管指定组织的队伍品牌四段文字。"
      />
      {loadError ? <Alert type="error" message={loadError} style={{ marginBottom: 12 }} /> : null}
      <Spin spinning={loading}>
        <div style={{ marginBottom: 8 }}>可代管组织</div>
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder="从组织目录勾选"
          value={selectedOrgs}
          onChange={setSelectedOrgs}
          options={orgOptions.map((name) => ({ value: name, label: name }))}
        />
        <div style={{ marginTop: 12 }}>
          <Button onClick={() => setSelectedOrgs([])}>清空</Button>
        </div>
      </Spin>
    </Modal>
  );
}
